import { z } from 'zod';

import { emailReg, INVALID_EMAIL, REQUIRED } from '@/components/Form/validation';

// One message per field, not one per entry: `z.array(z.string().regex(...))`
// reports at `errors.to[i]` and leaves `errors.to.message` undefined, which
// renders a red field with no text. A refine on the array keeps the single
// helper-text line this form has always shown.
const everyEntryIsAnEmail = (emails: readonly string[]) => emails.every((email) => emailReg.test(email));

export const sendByEmailFormSchema = z.object({
  // Addresses carry no `.trim()`: they are trimmed where they become a chip, so
  // the chip shows exactly what gets submitted (see EmailAutocomplete).
  to: z.array(z.string()).min(1, REQUIRED).refine(everyEntryIsAnEmail, { message: INVALID_EMAIL }),
  // Optional, but held to the same per-entry rule once it has entries.
  cc: z.array(z.string()).refine(everyEntryIsAnEmail, { message: INVALID_EMAIL }),
  subject: z.string().trim().min(1, REQUIRED),
  // The email body. `.trim()` strips only the outer whitespace, so the newlines
  // the default text carries survive.
  description: z.string().trim().min(1, REQUIRED),
});

export type SendByEmailFormData = z.infer<typeof sendByEmailFormSchema>;
